import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    fontSize: "20px",
    color: theme(props).typography.primary.color,
    lineHeight: "34px",
    marginBottom: 10,
    minHeight: 34,
    width: "75%",
}));
